"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;





















































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { upgradeId: 0, //升级任务id
      tableColumns: [{ prop: 'sn', label: '设备序列号' }, { prop: 'currentVersion', label: '当前版本号' }, { prop: 'createTime', label: '升级更新时间', formatter: _formatter.dateFormatter }, { prop: 'targetVersion', label: '升级目标版本号' }, { prop: 'status', label: '升级状态', formatter: _formatter.otaSituationStatusFormatter }, { prop: 'upgradeLog', label: '更新日志' }], //表格信息
      taskInfo: '' //升级情况信息
    };}, mounted: function mounted() {this.upgradeId = this.$route.params.parentId;this.initPage();}, computed: { moduleLabel: function moduleLabel() {switch (parseInt(this.taskInfo.type)) {case 1:return '中心板硬件';break;case 2:return 'WiFi板硬件';break;case 3:return '语音板硬件';break;case 4:return '机芯板板硬件';break;
        case 5:
          return '小腿板硬件';
          break;
        default:
          return '';
          break;}

    } },


  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchUpgradeTask();
    },

    /**
        * 获取升级情况列表
        */
    fetchUpgradeTask: function fetchUpgradeTask() {var _this = this;
      this.getData('/api/versionJob/getUpgradeTask/' + this.upgradeId, {}, function (res) {
        _this.taskInfo = res;
      });
    },

    /**
        * 返回
        */
    onClickReturn: function onClickReturn() {
      this.$router.push('/ota/upgrade');
    } } };exports.default = _default;